import Loading from '@/shared/components/Carregando';
import { DataAmigavel } from '@/shared/utils/datas';
import { Fragment, useEffect, useState } from 'react';
import { GetRelatorioLotacoesPorEstagiarios } from './lotacoes-estagiario.service';
import { IQueryComarcas, IQueryEstagiarios, IQueryPredios } from '@/api.types';
import { toast } from 'react-toastify';

interface IMyProps {
  exibirEventos: boolean;
}

export default function RelatorioEstagiariosSetores({
  exibirEventos,
}: IMyProps) {
  const [loading, setLoading] = useState<boolean>(true);
  const [relatorio, setRelatorio] = useState<IQueryComarcas[]>([]);

  useEffect(() => {
    GetRelatorioLotacoesPorEstagiarios()
      .then((result) => {
        setRelatorio(result);
        setLoading(false);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, [exibirEventos]);

  function RenderizarPrediosDaComarca(comarca: IQueryComarcas) {
    const elementos: JSX.Element[] = [];

    if (!comarca.predios || comarca.predios.length <= 0) return elementos;

    comarca.predios.forEach((predio, index) => {
      // Um prédio sem setor não precisa ser renderizado.
      if (!predio.setores || predio.setores.length <= 0) return elementos;

      elementos.push(
        <Fragment key={`predio-${index}`}>
          <table className="table table-som table-bordered align-middle border border-dark m-0 p-0">
            <thead>
              <tr>
                <th>{predio.predio_nome}</th>
              </tr>
              <tr className="text-end">
                <td className="">
                  {''.concat(
                    predio.endereco_logradouro || '',
                    ', nº ',
                    predio.endereco_numero + ', ' + predio.endereco_bairro ||
                    '',
                    '. CEP: ',
                    predio.endereco_cep || '',
                    '. ',
                    predio.endereco_cidade || '',
                    ' - ',
                  )}
                  {'('.concat(
                    predio.telefoneprincipal_ddd || '',
                    ') ',
                    predio.telefoneprincipal_numero || '',
                  )}
                </td>
              </tr>
            </thead>
          </table>
          <table className="table table-sm table-bordered align-middle border border-dark text-center">
            <thead>
              <tr>
                <th style={{ width: '35%' }}>SETOR DE ATUAÇÃO</th>
                <th style={{ width: '32%' }}>RESPONSÁVEL</th>
                <th style={{ width: '33%' }}>ESTAGIÁRIO(A)</th>
              </tr>
            </thead>
            <tbody>{RenderizarSetoresDoPredio(predio)}</tbody>
          </table>
        </Fragment>,
      );
    });

    return elementos;
  }

  function RenderizarSetoresDoPredio(predio: IQueryPredios) {
    const elementos: JSX.Element[] = [];

    // Renderiza os setores
    predio.setores?.forEach((setor, index) => {
      const maxEstagiarios = setor.estagiarios?.length || 0;
      const colunaEstagiarios = RenderizarColunaEstagiarios(
        setor.estagiarios,
        maxEstagiarios,
      );

      elementos.push(
        <Fragment key={`setor-${index}`}>
          <tr>
            <td rowSpan={colunaEstagiarios.length + 1}>
              <span className="text-center">{setor.nome}</span>
            </td>
            <td rowSpan={colunaEstagiarios.length + 1}>
              <span className="text-center">{setor.responsavel}</span>
            </td>
          </tr>
          {colunaEstagiarios}
        </Fragment>,
      );
    });

    return elementos;
  }

  function RenderizarColunaEstagiarios(
    estagiarios: IQueryEstagiarios[],
    max_estagiarios: number,
  ) {
    const elementos: JSX.Element[] = [];

    if (!estagiarios) return elementos;

    estagiarios.map((estagiario, index) => {
      return elementos.push(
        <tr
          key={'estagiario'.concat(
            estagiario.estagiario_nome.trim(),
            String(index),
          )}
        >
          <td>
            {estagiario.estagiario_nome}
            <br />
            <span className="text-muted small">
              ({DataAmigavel(estagiario.lotacoes_data_inicial)} a{' '}
              {DataAmigavel(estagiario.lotacoes_data_final)})
            </span>
            <br />
          </td>
        </tr>,
      );
    });

    if (estagiarios.length < max_estagiarios) {
      for (let i = estagiarios.length; i < max_estagiarios; i++) {
        elementos.push(
          <tr key={'estagiario'.concat('vago', String(i))}>
            <td>(VAGO)</td>
          </tr>,
        );
      }
    }
    return elementos;
  }

  if (loading) return Loading();

  return (
    <>
      <div className="col-12" id="conteudo">
        <div className="text-center">
          <h4 className="text-center relatorio-font relatorio-titulo">
            DEFENSORIA PÚBLICA DO ESTADO DE SERGIPE - TABELA DE LOTAÇÃO
          </h4>
          <span className="text-center ft-small">
            SUBDEFENSORIA - REVISADA EM{' '}
            <input
              title="Data"
              type="text"
              className="form-control-plaintext"
              style={{ width: '10%', display: 'inline' }}
              defaultValue={DataAmigavel(new Date(Date.now()))}
            />
          </span>
        </div>
        <br />

        {relatorio &&
          relatorio
            .filter(
              (comarca) =>
                Array.isArray(comarca.predios) &&
                comarca.predios.length > 0 &&
                comarca.predios.some(
                  (predio) =>
                    Array.isArray(predio.setores) && predio.setores.length > 0,
                ),
            )
            .map((comarca, index) => {
              return (
                <div key={index} className="relatorio">
                  <h5 className="relatorio-estagiarios-comarca">
                    {comarca.comarca_nome}
                  </h5>
                  {RenderizarPrediosDaComarca(comarca)}
                </div>
              );
            })}
      </div>
    </>
  );
}